function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFoodUpgradeMealFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.711 11.271V6.175c0-.57-.46-1.051-1.006-1.051-.544 0-1.005.481-1.005 1.05v5.141c0 .745-.587 1.378-1.3 1.378H5.33c-.712 0-1.299-.633-1.299-1.378v-5.14c0-.57-.46-1.051-1.006-1.051-.544 0-1.005.481-1.005 1.05v5.141c0 1.883 1.275 3.416 2.798 3.416v12.343h2.011V14.73c1.59 0 2.882-1.533 2.882-3.46z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.865 11.258c.456 0 .842-.403.842-.88V5.944c0-.477-.386-.88-.842-.88-.456 0-.842.403-.842.88v4.434c.035.476.386.88.842.88zM16.427 4.92c-3.103 0-5.619 2.628-5.619 5.87v4.381c0 .57.461 1.052 1.007 1.052h3.605V27.08h2.013V5.927c0-.57-.461-1.008-1.006-1.008zm-.965 9.2h-2.641v-3.33c0-1.709 1.132-3.198 2.641-3.636v6.966z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.773 20.573h5.477V18.91h-5.477v1.662zM29.988 13.201H27.25v4.866h-5.476v-4.866h-2.737l4.978-6.06a.679.679 0 01.504-.222.68.68 0 01.505.223l4.964 6.059zm-3.51-1.662l-1.96-2.393-1.966 2.393h.884v4.867h2.152v-4.867h.89z",
    fill: props.color
  }));
}

export default SvgIconFoodUpgradeMealFilled;